import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../../../utils/apiClient';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Card } from '../../../components/ui/card';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';

export default function GeneralSettings() {
  const { orgId } = useParams();
  const navigate = useNavigate();
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrg();
  }, [orgId]);

  const fetchOrg = async () => {
    try {
      const response = await apiClient.get(`/organizations/${orgId}`);
      setOrg(response.data);
    } catch (error) {
      console.error('Failed to fetch organization:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-8">Loading...</div>;
  }

  return (
    <div className="p-8 space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={() => navigate(`/enterprise/orgs/${orgId}/settings`)}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        <div>
          <h1 className="font-heading text-2xl font-bold text-gray-900">General Settings</h1>
          <p className="text-gray-600 mt-1">Organization identity and basic information</p>
        </div>
      </div>

      <Card className="p-6 rounded-lg space-y-4">
        <div>
          <Label>Organization Name</Label>
          <Input value={org?.name || ''} disabled className="mt-1" />
        </div>
        <div>
          <Label>Organization Slug</Label>
          <Input value={org?.slug || ''} disabled className="mt-1 font-mono" />
        </div>
        <div>
          <Label>Contact Email</Label>
          <Input value={org?.contactEmail || ''} disabled className="mt-1" />
        </div>
        <div>
          <Label>Description</Label>
          <Textarea value={org?.description || ''} disabled rows={3} className="mt-1" />
        </div>
        <p className="text-sm text-gray-500">
          Contact support to update organization details
        </p>
      </Card>
    </div>
  );
}
